"use strict";

// Estrutura e estilos do comprovanteFechamento do PDV web.
const CSS_FECHAMENTO = `
    @page {
        margin: 0;
    }

    body {
        margin: 0;
        padding: 0;
        color: #000;
    }

    .boxFull {
        width: calc(100% - 8mm);
        margin: 0 auto;
        color: #000;
        font-family: Courier, Arial, sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
    }

    .titulo {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
    }

    .subtitulo {
        margin: 3px 0 0;
        font-size: 10px;
        font-weight: 400;
        text-align: center;
    }

    .secao {
        padding: 6px 0;
    }

    .linha {
        border-top: 1px dashed #000;
        height: 1px;
    }

    .secao-titulo {
        margin: 0 0 3px;
        padding: 3px 0;
        background: #e6e6e6;
        font-size: 12px;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
    }

    .linha-info {
        width: 100%;
        margin: 0 0 1px;
        border-collapse: collapse;
    }

    .linha-info td {
        padding: 0;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.2;
        vertical-align: top;
    }

    .info-label {
        width: 52px;
        font-weight: 700;
        white-space: nowrap;
    }

    .info-valor {
        word-wrap: break-word;
    }

    .tabela {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    .tabela th,
    .tabela td {
        padding: 2px 0;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.2;
        vertical-align: top;
    }

    .tabela th {
        border-bottom: 1px dashed #000;
        font-weight: 700;
    }

    .descricao {
        text-align: left;
        width: 66%;
        word-wrap: break-word;
    }

    .valor {
        text-align: center;
        width: 34%;
        font-weight: 700;
        padding-right: 0;
        white-space: normal;
        overflow-wrap: anywhere;
    }
    .numero-monetario { display: inline-block; white-space: nowrap; }

    .total-final td {
        padding: 4px 0;
        border-top: 1px solid #000;
        background: #eeeeee;
        font-weight: 700;
    }

    .tabela-resumo td {
        font-size: 10px;
    }

    .tabela-resumo .descricao { width: 64%; }
    .tabela-resumo .valor { width: 36%; }

    .conferencia-grupo {
        width: 31%;
        text-align: left;
        white-space: normal;
    }

    .conferencia-valor {
        width: 23%;
        text-align: center;
        padding: 2px 1px;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .tabela-conferencia th,
    .tabela-conferencia td {
        font-size: 9px;
        line-height: 1.2;
    }

    .tabela-conferencia .conferencia-grupo { font-size: 10px; }
    .tabela-conferencia th.conferencia-valor { font-size: 8px; }
    .tabela-conferencia .total-final td {
        border-top: 1px dashed #000;
        background: transparent;
    }

    .sem-registro {
        margin: 0;
        font-size: 10px;
        font-weight: 400;
        text-align: center;
    }

    .rodape { margin: 6px 0; text-align: center; font-size: 10px; }
`;

const GRUPOS = {
  dinheiro: "Dinheiro", pix: "Pix", credito_loja: "Crédito loja",
  debito: "Débito", credito: "Crédito", beneficios: "Benefícios",
};
const numero = (valor) => Number.isFinite(Number(valor)) ? Number(valor) : 0;
const valor = (n) => numero(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const esc = (texto) => String(texto ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
function parse(value) {
  if (value && typeof value === "object") return value;
  try { return JSON.parse(value || "{}") || {}; } catch (_) { return {}; }
}
function dataHora(value) {
  const data = new Date(value);
  return Number.isNaN(data.getTime()) ? esc(value || "—") : data.toLocaleString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}
function linha(descricao, total, classe = "") {
  return `<tr class="${classe}"><td class="descricao">${esc(descricao)}</td><td class="valor">R$ <span class="numero-monetario">${valor(total)}</span></td></tr>`;
}
function ajustarValoresFechamento() {
  document.querySelectorAll(".boxFull .numero-monetario").forEach((numeroEl) => {
    const celula = numeroEl.closest("td");
    if (!celula) return;
    const css = getComputedStyle(celula);
    const disponivel = celula.getBoundingClientRect().width - (parseFloat(css.paddingLeft) || 0) - (parseFloat(css.paddingRight) || 0) - 2;
    if (disponivel <= 0) return;
    const largura = numeroEl.getBoundingClientRect().width;
    if (largura > disponivel) {
      const fonte = parseFloat(getComputedStyle(numeroEl).fontSize);
      numeroEl.style.fontSize = `${Math.max(5, Math.floor(fonte * disponivel / largura * 10) / 10 - 0.2)}px`;
    }
  });
}
const SCRIPT_AJUSTAR_VALORES_FECHAMENTO = `(${ajustarValoresFechamento.toString()})();`;
function pagamentos(titulo, dados, vazio) {
  const lista = Array.isArray(dados) ? dados.map((p) => [p.descricao, p.total]) : Object.entries(dados || {});
  return `<div class="secao"><p class="secao-titulo">${titulo}</p>${lista.length
    ? `<table class="tabela"><tbody>${lista.map(([nome, total]) => linha(nome, total)).join("")}</tbody></table>`
    : `<p class="sem-registro">${vazio}</p>`}</div><div class="linha"></div>`;
}

function gerarHtmlFechamento({ movimento, ctx = {}, versaoTemplate = "7" }) {
  const payload = parse(movimento.payload_json);
  const resumo = payload.resumo || {};
  const categorias = resumo.vendas_por_categoria || {};
  const informados = payload.fechamento_pagamentos;
  const gaveta = numero(resumo.valor_esperado ?? categorias.dinheiro ?? payload.valor_esperado);
  const eletronicos = numero(resumo.total_recebimentos_eletronicos ?? ["pix", "debito", "credito", "beneficios"].reduce((total, key) => total + numero(categorias[key]), 0));
  const esperadoGrupo = (key) => key === "dinheiro" ? gaveta : numero(categorias[key]);
  const totalEsperado = Object.keys(GRUPOS).reduce((total, key) => total + esperadoGrupo(key), 0);
  const totalInformado = Object.keys(GRUPOS).reduce((total, key) => total + numero(informados?.[key]), 0);
  const conferencia = informados && typeof informados === "object" ? `
    <div class="linha"></div><div class="secao">
    <p class="secao-titulo">Conferência do fechamento</p>
    <table class="tabela tabela-conferencia"><thead><tr>
      <th class="conferencia-grupo">Grupo</th><th class="conferencia-valor">Esp. (R$)</th>
      <th class="conferencia-valor">Inf. (R$)</th><th class="conferencia-valor">Dif. (R$)</th>
    </tr></thead><tbody>${Object.entries(GRUPOS).map(([key, titulo]) => `<tr>
      <td class="conferencia-grupo">${titulo}</td><td class="conferencia-valor"><span class="numero-monetario">${valor(esperadoGrupo(key))}</span></td>
      <td class="conferencia-valor"><span class="numero-monetario">${valor(informados[key])}</span></td><td class="conferencia-valor"><span class="numero-monetario">${valor(numero(informados[key]) - esperadoGrupo(key))}</span></td>
    </tr>`).join("")}<tr class="total-final"><td class="conferencia-grupo">Total</td>
      <td class="conferencia-valor"><span class="numero-monetario">${valor(totalEsperado)}</span></td><td class="conferencia-valor"><span class="numero-monetario">${valor(totalInformado)}</span></td>
      <td class="conferencia-valor"><span class="numero-monetario">${valor(totalInformado - totalEsperado)}</span></td></tr></tbody></table></div>` : "";
  const empresa = ctx.emitente?.razao_social || ctx.emitente?.nome_fantasia || ctx.emitente?.nome || "";
  const operador = movimento.nome_usuario || ctx.operador?.nome || movimento.id_usuario || "";
  const resumoLinhas = [
    ["Total de vendas", resumo.total_vendas], ["Total de contas recebidas", resumo.total_contas_recebidas],
    ["Vendas canceladas (-)", resumo.total_vendas_canceladas], ["Abertura de caixa (+)", resumo.abertura],
    ["Suprimento (+)", resumo.suprimentos], ["Sangria (-)", resumo.sangrias_operacionais ?? resumo.sangrias],
    ["Total na gaveta", gaveta], ["Recebimentos eletrônicos", eletronicos],
  ];
  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8">
    <meta name="caixa-comprovante-template" content="${versaoTemplate}"><title>Fechamento de Caixa</title>
    <style>${CSS_FECHAMENTO}
      * { box-sizing: border-box; } html, body { width: 80mm; }
      .boxFull { padding: 0; } @media print { html, body { margin: 0; } }
      .info-label { padding-right: 3px !important; }
    </style></head><body><div class="boxFull">
    <div class="secao"><h2 class="titulo">Fechamento de Caixa</h2><p class="subtitulo">Resumo de conferência do movimento</p></div>
    <div class="linha"></div><div class="secao">
      <table class="linha-info"><tr><td class="info-label">Empresa:</td><td class="info-valor">${esc(empresa)}</td></tr></table>
      <table class="linha-info"><tr><td class="info-label">Caixa:</td><td class="info-valor">${esc(operador)}</td></tr></table>
      <table class="linha-info"><tr><td class="info-label">Data:</td><td class="info-valor">${dataHora(movimento.data_fechamento || movimento.created_at)}</td></tr></table>
    </div><div class="linha"></div>
    ${pagamentos("Totais vendas", resumo.vendas_por_forma, "Nenhuma venda localizada no período.")}
    ${pagamentos("Totais recebimentos", resumo.pagamentos_recebimentos, "Nenhum recebimento localizado no período.")}
    <div class="secao"><p class="secao-titulo">Resumo do caixa</p><table class="tabela tabela-resumo"><tbody>
      ${resumoLinhas.map(([descricao, total]) => linha(descricao, total)).join("")}
      ${linha("TOTAL DO CAIXA (=)", resumo.total_caixa ?? gaveta + eletronicos, "total-final")}
    </tbody></table></div>${conferencia}
    ${payload.observacao ? `<div class="rodape">Obs.: ${esc(payload.observacao)}</div>` : ""}
    </div></body></html>`;
}

module.exports = { gerarHtmlFechamento, SCRIPT_AJUSTAR_VALORES_FECHAMENTO };
